import * as st from "lib/utils/socialtravel";
import BaseDecorator from "./BaseDecorator";
import PaymentProfileInstallmentDecorator from "./PaymentProfileInstallmentDecorator";

@BaseDecorator.translates(["name", "cancellation_policy", "additional_fee_name"])
export default class PaymentProfileDecorator extends BaseDecorator {
  static build(data = {}) {
    return new this({
      _new: true,
      id: null,
      uuid: st.generateUuid(),
      type: "PaymentProfile",
      has_additional_fee: false,
      additional_fee: null,
      additional_fee_percentage: null,
      additional_fee_as_agent_fee: false,
      marketplace: false,
      translations: [],
      installments: [
        {
          uuid: st.generateUuid(),
          receiver: "supplier",
          transfer_type: "cash",
          amount_type: "remaining_amount",
          paid_by_type: "on_stock_starts_at",
          confirmation_installment: false,
          paid_after_company_approval: true,
        },
      ],
      ...data,
    });
  }

  constructor(data) {
    super({
      ...data,
      installments: data.installments
        .map((x) => new PaymentProfileInstallmentDecorator(x))
        .sort((a, b) => a.position - b.position),
    });
  }

  get additional_fee_formatted() {
    return this.additional_fee && this.additional_fee.value
      ? st.formatMoney(this.additional_fee)
      : st.formatPercentage(this.additional_fee_percentage);
  }

  get additional_fee_or_percentage() {
    if (this.additional_fee_percentage) {
      return {
        value: this.additional_fee_percentage,
        currency: "percentage",
      };
    } else {
      return this.additional_fee;
    }
  }

  set additional_fee_or_percentage(additional_fee_or_percentage) {
    if (!additional_fee_or_percentage) {
      this.additional_fee = null;
      this.additional_fee_percentage = null;
    } else if (additional_fee_or_percentage.currency === "percentage") {
      this.additional_fee = null;
      this.additional_fee_percentage = additional_fee_or_percentage.value;
    } else {
      this.additional_fee = additional_fee_or_percentage;
      this.additional_fee_percentage = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/PaymentProfileDecorator.js